import React from 'react';
import { Route } from 'react-router-dom';

function PublicRoute({ component: Component, title, banner, ...rest }) {
  document.title = `${title} | ${banner}`;

  return (
      <Route {...rest} render={props => <Component {...props} />} />
  );
}

export default PublicRoute;